import { render, staticRenderFns } from "./TemplateMappingsCustomisation.vue?vue&type=template&id=ce509502&"
import script from "./TemplateMappingsCustomisation.vue?vue&type=script&lang=ts&"
export * from "./TemplateMappingsCustomisation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports